import { gql } from '@apollo/client';

export interface GetLessonFolderVariables {
    where: {
        id: string;
    };
}

export interface GetLessonFolderResponse {
    lessonFolder: {
        id: string;
        name: string;
        shares: {
            id: string;
            user?: {
                name: string;
                email: string;
            };
            email: string;
        }[];
        teacher: {
            user: {
                name: string;
                email: string;
            };
        };
    };
}

export const GET_LESSON_FOLDER = gql`
    query LessonFolder($where: LessonFolderWhereUniqueInput!) {
        lessonFolder(where: $where) {
            id
            name
            shares {
                id
                user {
                    name
                    email
                }
                email
            }
            teacher {
                user {
                    name
                    email
                }
            }
        }
    }
`;

export interface CreateLessonFolderSharesVariables {
    data: {
        email: string;
        lessonFolder: {
            connect: { id: string };
        };
        user: {
            connect: { email: string };
        };
    }[];
}

export interface CreateLessonFolderSharesResponse {
    createLessonFolderShares: {
        id: string;
        email: string;
    }[];
}

export const CREATE_LESSON_FOLDER_SHARES = gql`
    mutation CreateLessonFolderShares($data: [LessonFolderShareCreateInput!]!) {
        createLessonFolderShares(data: $data) {
            id
            email
        }
    }
`;

export interface DeleteLessonFolderShareVariables {
    where: {
        id: string;
    }[];
}

export interface DeleteLessonFolderShareResponse {
    deleteLessonFolderShares: {
        id: string;
        email: string;
    }[];
}

export const DELETE_LESSON_FOLDER_SHARES = gql`
    mutation DeleteLessonFolderShares($where: [LessonFolderShareWhereUniqueInput!]!) {
        deleteLessonFolderShares(where: $where) {
            id
            email
        }
    }
`;
